import React from 'react';

const privacyPolicyContent = [
  {
    title: '一、信息收集',
    content: '1. 基本信息：手机号码（用于登录验证）\n2. 家庭组信息：您创建或加入的家庭组数据\n3. 往来记录：您记录的人情往来信息\n4. 设备信息：设备型号、操作系统版本等'
  },
  {
    title: '二、信息使用',
    content: '1. 提供服务：为您提供人情往来记录和管理功能\n2. 账户安全：验证用户身份，保护账户安全\n3. 改进服务：分析使用情况，优化产品体验'
  },
  {
    title: '三、信息存储',
    content: '1. 我们会将您的数据存储在安全可靠的服务器上\n2. 除非法律要求或您同意，我们不会向第三方透露您的个人信息\n3. 您可以随时删除您的账户和个人数据'
  },
  {
    title: '四、信息保护',
    content: '我们采用行业标准的安全措施保护您的个人信息，包括加密传输、安全存储等。'
  },
  {
    title: '五、您的权利',
    content: '1. 访问权：您有权查看我们存储的您的个人信息\n2. 更正权：您有权更正不准确的个人信息\n3. 删除权：您有权要求删除您的个人信息\n4. 注销权：您有权注销您的账户'
  },
  {
    title: '六、未成年人保护',
    content: '我们建议未成年人在父母或监护人的指导下使用我们的服务。'
  },
  {
    title: '七、联系我们',
    content: '如您对本隐私政策有任何疑问，请联系我们。'
  }
];

export default function PrivacyPolicy() {
  return (
    <div className="page-content">
      <h2 className="page-title">隐私政策</h2>
      <p className="update-time">更新时间：2026年5月10日</p>

      {privacyPolicyContent.map((section, index) => (
        <div key={index} className="section">
          <h3 className="section-title">{section.title}</h3>
          <div className="section-content">
            {section.content.split('\n').map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}